import axios from "axios";

export async function getSubSampleImg({ commit }, payload) {
  try {
    const { data } = await axios.get("/sample/sub-sample-img", {
      params: payload,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.message);
  }
}
